module.exports = __webpack_public_path__ + "static/media/Hbook-08.cefe4195.jpg";